<template>
  <div class="block-downloaddocumentation" id="download-documentation">
    <bimContainer>
      <bimCol cols=12 md=10 class="mx-auto">
        <bim-text adaptive type=h4 bold class="text-center">Загрузите документацию</bim-text>
        <bim-text adaptive type=accent bold class="mt-10 mb-11 text-center">Мы сделаем всё остальное</bim-text>

        <a class="d-block" href="#download-documentation">
          <upload-files
            class="upload-file"
            :value="file_list"
            id-input="upload-file"
            ref="uploadFile"
            name="documents"
            @change="uploadFiles"
            :uploading="uploading"
          >
            <div class="upload-file__inner d-flex flex-column align-center justify-center">
              <svg class="upload-file__icon-wrapper">
                <use class="upload-file__icon" xlink:href="/dist/assets/front_white/img/icons/file_big.svg#file_big"></use>
              </svg>
              <bim-text adaptive type=main bold class="my-6 upload-file__title">Перетащите файлы или нажмите на область</bim-text>
              <bim-text adaptive type="desc" class="d-inline-flex align-center">
                файл в формате .gsfx
              </bim-text>
            </div>
          </upload-files>
        </a>

        <bim-text adaptive type=main class="text-center mt-10">Стоимость 100₽ за позицию</bim-text>
      </bimCol>
    </bimContainer>
    <DownloadPopup v-model="showDownloadPopup" :file="file" />
  </div>
</template>

<script>
import uploadFiles from '@/components/lk/models/UploadFiles'
import DownloadPopup from "./download-popup"
import bimContainer from "@bimlib/components/bimContainer"
import bimCol from "@bimlib/components/bimCol"
const img_catalog = "/dist/assets/front_white/img/landing_estimate/"
export default {
  name: "",
  components: {
    uploadFiles,
    bimContainer,
    bimCol,
    DownloadPopup,
  },
  data() {
    return {
      file_list: [],
      uploading: false,
      valid: false,
      showDownloadPopup: false,
      showSendRequest: false,
      file: null,
    }
  },
  methods: {
    async uploadFiles(event) {
      const file = event.target ? event.target.files : event

      this.uploading = true
      console.log(file)

      try {
        this.file = file[0]
        this.valid = true
        this.showDownloadPopup = true
      } catch (e) {
        this.$toast('Ошибка загрузки файла. Попробуйте снова', { title: 'Ошибка... :(' })
      }
      finally {
        this.uploading = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.text-center {
  text-align: center;
}
.block-downloaddocumentation {
  background-color: $white-color-50;
  padding: 64px 0 42px;
}
.upload-file {
  text-align: center;
  margin: auto;
  max-width: 685px;
  border: 2px dashed $primary-color;
  background-color: $primary-color-75;
  height: auto;
  padding: 84px 0;

  &:hover {
    background-color: $primary-color-75;
  }

  .upload-file__icon-wrapper {
    width: 22px;
    height: 26px;
  }

  .upload-file__title {
    color: $primary-color;
    max-width: 220px;
  }
}
</style>
